import PicturesApp from 'station/components/picture/PicturesApp'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitleWithTownName } from 'utils/StationUtils'

const HydrometryPicturesApp = ({

}) => {
    const {
        hydrometricStation,
        hydrometricStations,
        citiesIndex,
    } = useSelector(store => ({
        hydrometricStation: store.HydrometryReducer.hydrometricStation,
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const townName = useMemo(() => citiesIndex[hydrometricStation.townCode]?.name, [citiesIndex, hydrometricStation])

    useTitle(() => [{
        title: i18n.hydrometry,
        href: 'hydrometry',
    }, {
        title: getStationTitleWithTownName(hydrometricStation, townName),
        href: `station/hydrometry/${hydrometricStation?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/hydrometry/${hydrometricStation?.id}/picture`,
    }], [hydrometricStation, townName])

    return (
        <PicturesApp
            stations={hydrometricStations}
            station={hydrometricStation}
            stationType='hydrometry'
        />
    )
}

export default HydrometryPicturesApp